import { render, staticRenderFns } from "./revision-anual-editar.vue?vue&type=template&id=464eccd2&"
import script from "./revision-anual-editar.vue?vue&type=script&lang=js&"
export * from "./revision-anual-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports